import { render, staticRenderFns } from "./CloIcon.vue?vue&type=template&id=74faa429&"
import script from "./CloIcon.vue?vue&type=script&lang=js&"
export * from "./CloIcon.vue?vue&type=script&lang=js&"
import style0 from "./CloIcon.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports